<app-navigation tagline="TIPPS" marginLeftClass="ml-20"></app-navigation>
<ion-content>
  <div class="ion-margin slide tipps">
    <app-tipps [part]="1"></app-tipps>
    <app-tipps [part]="2"></app-tipps>
    <app-tipps [part]="3"></app-tipps>
    <app-tipps [part]="4"></app-tipps>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
